import React, {
    useContext,
    useState,
    useRef,
    useEffect,
} from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';

import { refetchBasketData, NotificationContext, handleError } from "../router";

import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";

import TicketTypeSelect from '../components/ticket-type-select';
import CrossIcon from "../svg/cross";
import InfoCircle from "../svg/info-circle";


export default function Ticket(props) {

    const {notification, setNotification} = useContext(NotificationContext);

    const [message, setMessage] = useState(null);
    const [seatInfo, setSeatInfo] = useState(null);
    const dialogRef = useRef(null);

    const removeTicket = useMutation({
        mutationFn: () => QUERIES.removeTickets([props.ticket.id]),
        onError: (error) => {
            props.setRemoveTicketPending(false)
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            props.setRemoveTicketPending(false)
            // Remove from the render so it doesn't flash while getBasket is refreshing
            refetchBasketData();
        },
    });
           
    const { data: seatStatusData } = useQuery({
        queryKey: ['seatStatusData', CONSTANTS.INSTANCE_ID],
        queryFn: QUERIES.getSeatData,
        retry: false
    });
    
    useEffect(() => {
        if (!seatStatusData?.info || !props.ticket?.seat) return;

        // Find out if there is extra info
        if (seatStatusData.info[props.ticket.seat.id]) {
            setSeatInfo(seatStatusData.info[props.ticket.seat.id]);
        }

    }, [seatStatusData]);

    return (
        <div className='select-ticket-type'>
            {message &&
                <p className='confirmation-message'>{message}</p>
            }
            {removeTicket.error && removeTicket.error &&
                <p className='error-message'>{removeTicket.error.message}</p>
            }
            <div className='select-ticket-type__header'>
                <p className='select-ticket-type__title'>{ props.ticket.planName }</p>
                {props.ticket.seat?.name &&
                    <p className='select-ticket-type__name'>{ props.ticket.seat.name }</p>
                }
                {seatInfo &&
                    <p className='select-ticket-type__seat-info'><InfoCircle /> {seatInfo.priceBandId.replaceAll("+"," ")}</p>
                }
                {props.ticket.seat?.attribute_ViewFromSeatImage ?
                    <button type="button" 
                            className='select-ticket-type__view-button'
                            onClick={() => dialogRef.current.showModal()}>
                        View from seated area
                    </button>
                :null}
            </div>

            <TicketTypeSelect ticket={props.ticket} setMessage={setMessage} pricelist={props.pricelist} />

            <button type="button" onClick={() => {removeTicket.mutateAsync(); props.setRemoveTicketPending(true);}} className='btn btn--remove'>
                <span className='sr-text'>Remove ticket</span>
                <CrossIcon />
            </button>

            {props.ticket.seat?.attribute_ViewFromSeatImage ?
                <dialog ref={dialogRef} className='seat-info-dialog'>
                    <div className='dialog-container'>
                        <button type="button" className='btn--cross btn--dialog-close' onClick={() => dialogRef.current.close()}>
                            <span className='sr-text'>Close dialog</span>
                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="36" y="23" width="2" height="24" transform="rotate(90 36 23)"/>
                                <rect x="23" y="12" width="2" height="24" />
                            </svg>
                        </button>
                        <div className='dialog-content'>

                            <h1 className='seat-info-dialog__header'>{ props.ticket.planName }</h1>
                            {props.ticket.seat?.name &&
                                <p className='seat-info-dialog__seat-name'>{ props.ticket.seat.name }</p>
                            }
                            {props.ticket.seat?.attribute_ViewFromSeatImage &&
                                <>
                                    <img src={props.ticket.seat.attribute_ViewFromSeatImage} alt="image of view from seat" className='seat-info-dialog__image' />
                                    <p className='seat-info-dialog__image--info'>Images are illustrative of approximate views</p>
                                </>
                            }
                        </div>
                    </div>
                </dialog>
            :null}
        </div>
    )
}